module.exports = __webpack_public_path__ + "img/vip1.0fa54904.png";